<template>
  <nav class="nav-menu-left pad-t-15">
    <!--页面刷新会保存状态$route.path-->
    <el-scrollbar scroll-y="false"
                  style="height: 100%;padding-bottom:40px">
      <div>
        <el-menu :collapse="true"
                 :router="true"
                 :default-active="$route.fullPath">
          <!-- <el-submenu index="1" v-if="filterFunctions.includes('xtgl')">
          <template slot="title">系统管理</template>
          <el-menu-item index="1-1">系统管理</el-menu-item>
        </el-submenu>-->
          <el-submenu index="2"
                      v-if="filterFunctions.includes('xxgl')">
            <template slot="title">基础管理</template>
            <el-submenu index="2-1"
                        v-if="filterFunctions.includes('xxgl')">
              <template slot="title">信息管理</template>
              <el-menu-item v-if="filterFunctions.includes('xxgl-xxgl')"
                            index="/manage/messageManageList">消息列表</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="3"
                      v-if="filterFunctions.includes('hygl')">
            <template slot="title">会员管理</template>
            <el-submenu index="3-1">
              <template slot="title">会员管理</template>
              <el-menu-item v-if="filterFunctions.includes('hygl-hygl')"
                            index="/manage/memberAuditList">会员管理</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="4"
                      v-if="
            filterFunctions.includes('bcgl') ||
              filterFunctions.includes('ccxx') ||
              filterFunctions.includes('ykgl') ||
              filterFunctions.includes('kcgl') ||
              filterFunctions.includes('ckgl')
          ">
            <template slot="title">仓库管理</template>
            <el-submenu index="4-1"
                        v-if="filterFunctions.includes('bcgl')">
              <template slot="title">包材管理</template>
              <el-menu-item v-if="filterFunctions.includes('bcgl-bcgl')"
                            index="/manage/packingManageList">包材管理</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('bcgl-bcbzgl')"
                            index="/manage/packingMaterialList">包材标准管理</el-menu-item>
            </el-submenu>
            <el-submenu index="4-2"
                        v-if="filterFunctions.includes('ccxx')">
              <template slot="title">仓储信息</template>
              <el-menu-item v-if="filterFunctions.includes('ccxx-ckxx')"
                            index="/manage/storehouseManageList">仓库信息</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('ccxx-kqxx')"
                            index="/manage/warehouseManageList">库区信息</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('ccxx-kwxx')"
                            index="/manage/sinkData">库位信息</el-menu-item>
            </el-submenu>
            <el-submenu index="4-3"
                        v-if="filterFunctions.includes('ykgl')">
              <template slot="title">移库管理</template>
              <el-menu-item v-if="filterFunctions.includes('ykgl-yktz')"
                            index="/manage/taskReceivingList">移库通知</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('ykgl-ykzx')"
                            index="/manage/moveLibraryTaskList">移库执行</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('ykgl-yksh')"
                            index="/manage/confirmAuditList">移库审核</el-menu-item>
            </el-submenu>
            <el-submenu index="4-4"
                        v-if="filterFunctions.includes('kcgl')">
              <template slot="title">库存管理</template>
              <el-menu-item v-if="filterFunctions.includes('kcgl-kcgl')"
                            index="/manage/inventoryQueryList">库存管理</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('kcgl-kcpd')"
                            index="/manage/inventoryCheckList">库存盘点</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('kcgl-pdsh')"
                            index="/manage/earningsLossesList">盘点审核</el-menu-item>
            </el-submenu>
            <el-submenu index="4-5"
                        v-if="filterFunctions.includes('ckgl')">
              <template slot="title">出库管理</template>
              <el-menu-item v-if="filterFunctions.includes('ckgl-ckgl')"
                            index="/manage/shipmentManageList">出库管理</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="5"
                      v-if="
            filterFunctions.includes('wtgl') || filterFunctions.includes('yygl')
          ">
            <template slot="title">委托管理</template>
            <el-submenu index="5-1"
                        v-if="filterFunctions.includes('yygl')">
              <template slot="title">预约管理</template>
              <el-menu-item v-if="filterFunctions.includes('yygl-yysh')"
                            index="/manage/initialInspectionList">预约审核</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('yygl-yygl')"
                            index="/manage/appointmentManageList">预约管理</el-menu-item>
            </el-submenu>
            <el-submenu index="5-2"
                        v-if="filterFunctions.includes('wtgl')">
              <template slot="title">委托管理</template>
              <el-menu-item v-if="filterFunctions.includes('wtgl-wtgl')"
                            index="/manage/entrustManageList">委托管理</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('wtgl-hwwt')"
                            index="/manage/goodsEntrustManageList">货物委托</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="6"
                      v-if="filterFunctions.includes('bdgl') || filterFunctions.includes('tcgl') || filterFunctions.includes('zjgl')">
            <template slot="title">质检管理</template>
            <el-submenu index="6-1">
              <template slot="title">质检管理</template>
              <el-menu-item v-if="filterFunctions.includes('zjgl-bdgl')"
                            index="/manage/auctionTargetList">标的管理</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('zjgl-tcgl')"
                            index="/manage/setMealList">套餐管理</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('zjgl-zjgl')"
                            index="/manage/qualityControlList">质检管理</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="7"
                      v-if="
            filterFunctions.includes('pmgl') || filterFunctions.includes('dpgl')
          ">
            <template slot="title">拍卖管理</template>
            <el-submenu index="7-1"
                        v-if="filterFunctions.includes('pmgl')">
              <template slot="title">拍卖管理</template>
              <el-menu-item v-if="filterFunctions.includes('pmgl-pmgl')"
                            index="/auction-function/auctionIndex">拍卖管理</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('pmgl-pmsh')"
                            index="/auction-function/auditAuctionIndex">拍卖审核</el-menu-item>
              <el-menu-item v-if="filterFunctions.includes('pmgl-cbgl')"
                            index="/auction-function/reviewMark">撤标管理</el-menu-item>
            </el-submenu>
            <el-submenu index="7-2"
                        v-if="filterFunctions.includes('dpgl')">
              <template slot="title">大屏管理</template>
              <a v-if="filterFunctions.includes('dpgl-xxcj')"
                 :href="SCREEN_URL"
                 target="_blank"
                 style="display: inline-block;width: 100%;height: 50px;line-height: 50px;background: #231c12;color: #fff;padding-left: 20px;">线下出价</a>
              <!-- <a v-if="filterFunctions.includes('dpgl-dpyl')" :href="SCREEN_URL" target="_blank" style="display: inline-block;width: 100%;height: 50px;line-height: 50px;background: #231c12;color: #fff;padding-left: 20px;">大屏预览</a> -->
            </el-submenu>
          </el-submenu>
          <el-submenu index="8"
                      v-if="filterFunctions.includes('ddzx')">
            <template slot="title">订单管理</template>
            <a v-if="filterFunctions.includes('ddzx-ddgl')"
               :href="FINANCE_URL"
               target="_blank"
               style="display: inline-block;width: 100%;height: 50px;line-height: 50px;background: #231c12;color: #fff;padding-left: 20px;">业财一体化</a>
            <el-menu-item v-if="filterFunctions.includes('ddzx-cjdd')"
                          index="/manage/orderManage/transactionOrderList">成交订单</el-menu-item>
          </el-submenu>

        </el-menu>
      </div>
    </el-scrollbar>

    <div class="fixed-text">
      <div>技术支持</div>
      <div>
        <a href="https://www.paohe.cn/"
           target="_blank">广东跑合中药材电子商务有限公司</a>
      </div>
    </div>
  </nav>
</template>

<script>
import { FINANCE_URL, SCREEN_URL } from "../../config/env";
export default {
  name: "navMenuLeft",
  created () {
    //订单跳转到业财一体化
    if (FINANCE_URL) {
      this.FINANCE_URL = FINANCE_URL;
    }
    if (SCREEN_URL) {
      this.SCREEN_URL = SCREEN_URL;
    }
    //如果本地有权限
    if (localStorage.functions.length > 0) {
      this.functions = JSON.parse(localStorage.functions);
      this.functions.forEach(item => {
        if (item.functionCode) {
          this.filterFunctions.push(item.functionCode);
        }
      });
    }
  },
  data () {
    return {
      functions: [], //原菜单
      filterFunctions: [], //过滤后菜单
      FINANCE_URL: "", //订单跳转到业财一体化
      SCREEN_URL: "", //一体机
      screenHref: `${window.location.protocol}//${window.location.host}/login`
    };
  }
};
</script>

<style lang="css">
.nav-menu-left {
  width: 200px;
  height: 100%;
  position: fixed;
  z-index: 10;
  margin: 0;
  top: 3.6rem;
  height: 100%;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  background: #33291d;
}
.el-menu {
  width: 100%;
  background: #33291d;
  border-right: none;
}
.el-menu--popup {
  padding: 0;
  min-width: 152px;
}
.el-menu-item,
.el-submenu__title,
.el-menu-item-group__title {
  color: #fff;
  padding: 0 30px;
  height: 45px;
  line-height: 45px;
  cursor: pointer;
}
.el-menu-item:focus,
.el-menu-item:hover,
.el-menu-item-group__title:hover {
  outline: 0;
  background: #231c12;
}
.el-menu-item.is-active {
  color: #fff;
  background: #ab5d01;
}
.el-menu-item i {
  color: #fff;
}
.el-submenu__title:hover i {
  color: #fff;
}
.el-menu--collapse > .el-menu-item span,
.el-menu--collapse > .el-submenu > .el-submenu__title span {
  color: #fff;
  overflow: visible;
  visibility: visible;
  display: inline;
}
.el-submenu__title:hover {
  background: #231c12;
  color: #fff;
}
.el-menu.is-active {
  color: #fff !important;
  background: #ab5d01 !important;
}
.el-submenu.is-active {
  color: #fff !important;
  background: #ab5d01 !important;
}
.el-submenu.is-active:hover .el-submenu__title {
  color: #fff !important;
  background: #ab5d01 !important;
}
.el-submenu.is-active i {
  color: #fff;
}
.el-submenu.is-active:hover {
  color: #fff !important;
  background: #ab5d01 !important;
}
.el-menu--collapse > .el-menu-item .el-submenu__icon-arrow,
.el-menu--collapse > .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  display: block;
}
.fixed-text {
  position: absolute;
  left: 10px;
  bottom: 80px;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
  color: #999;
}
.fixed-text a {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/NavMenuLeft.vue